import {ActionIcon, Grid, Group} from "@mantine/core";
import {
  DispatchRequestFilterFormValues,
  IncrementalDateInput,
  isDefaultDispatchRequestFilter
} from "@ots-frontend/ots-ui";
import {IconFilter, IconSearch} from "@tabler/icons-react";

type DispatchRequestToolbarProps = {
  date: Date
  onDateChange: (d: Date) => void
  showSearch: boolean
  onSearchClick: () => void
  filter: DispatchRequestFilterFormValues,
  onFilterClick: () => void
  isLoading?: boolean
}

export const DispatchRequestToolbar = (props: DispatchRequestToolbarProps) => {
  const {
    date,
    onDateChange,
    showSearch,
    onSearchClick,
    filter,
    onFilterClick,
  } = props;

  return (
    <Grid p="xs">
      <Grid.Col span={4}>
        <Group position="left" align="center">
          <ActionIcon
            variant={showSearch ? "filled" : "subtle"}
            color={showSearch ? "primary" : undefined}
            onClick={onSearchClick}>
            <IconSearch size="1.125rem"/>
          </ActionIcon>
          <ActionIcon
            variant={!isDefaultDispatchRequestFilter(filter) ? "filled" : "subtle"}
            color={!isDefaultDispatchRequestFilter(filter) ? "service-work" : undefined}
            onClick={onFilterClick}>
            <IconFilter size="1.125rem"/>
          </ActionIcon>
        </Group>
      </Grid.Col>
      <Grid.Col span={4}>
        <IncrementalDateInput
          defaultValue={date}
          onDateChange={onDateChange}
          popoverProps={{
            withinPortal: true
          }}/>
      </Grid.Col>
      <Grid.Col span={4}>
      </Grid.Col>
    </Grid>
  );
};
